import axios from 'axios';
import * as TYPE from './types';
import config from '../../../config';

// PDF generation stays as thunks (RTK Query migration exclusion): the
// GET endpoint streams the report payload back, the POST starts an async
// generation, and neither benefits from caching.
//
// Auth headers are derived from `state.session.current` on every call.
// The legacy apiMiddleware used to maintain axios.defaults; that's gone
// now, so we set per-request headers here instead.

function authHeaders(getState) {
  const session = getState().session?.current;
  const headers = {};
  if (session?.token) headers.Authorization = `Bearer ${session.token}`;
  if (session?.tenant) headers['X-Tenant-Id'] = session.tenant;
  return headers;
}

export function generateInspectionPdf(inspectionId) {
  return async (dispatch, getState) => {
    try {
      const { data } = await axios.get(
        `${config.apiBaseUrl}/exports/control/${inspectionId}`,
        { headers: authHeaders(getState) },
      );
      dispatch({ type: TYPE.GENERATE_INSPECTION_PDF_SUCCESS, payload: data });
      return data;
    } catch (error) {
      dispatch({
        type: TYPE.GENERATE_INSPECTION_PDF_FAILED,
        payload: { error },
      });
      throw error;
    }
  };
}

export function startInspectionPdfGeneration(inspectionId) {
  return async (dispatch, getState) => {
    try {
      const { data } = await axios.post(
        `${config.apiBaseUrl}/exports/control/${inspectionId}/pdf`,
        {},
        { headers: authHeaders(getState) },
      );
      dispatch({
        type: TYPE.START_INSPECTION_PDF_GENERATION_SUCCESS,
        payload: data,
      });
      return data;
    } catch (error) {
      dispatch({
        type: TYPE.START_INSPECTION_PDF_GENERATION_FAILED,
        payload: { error },
      });
      throw error;
    }
  };
}

// Resets `current.inspectionReport` to null. Called immediately after the
// report HTML is handed to `window.open(...)` so a subsequent navigation
// to a different inspection detail page doesn't see the stale payload and
// re-open the popup.
export function clearInspectionReport() {
  return { type: TYPE.CLEAR_INSPECTION_REPORT };
}
